import React, { useEffect } from "react";
import ProductProcessStatusAssignedViewModel from "../../../viewmodels/setup/processStatus/ProductProcessStatusAssignedViewModel";
import { SnackbarType, SnackbarData } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";
import AssignPickList from "../../../components/assignPickList/assignPickList";

export default function ProductProcessStatusAssigned(props: any) {
  const { productId, logout, addSnackbar } = props;

  const {
    loading,
    getStatusesForProduct,
    updateProductProcessStatuses,
    setUpdatedCurrentStatuses,
    updatedCurrentStatuses,
  } = ProductProcessStatusAssignedViewModel(logout, addSnackbar);

  useEffect(() => {
    if (productId) {
      getStatusesForProduct(productId);
    }
  }, [productId]);

  const sourceItemTemplate = (item: any) => {
    return <div className="px-3 py-2 text-sm text-gray-700">{item.name}</div>;
  };

  const targetItemTemplate = (item: any) => {
    return (
      <div className="px-3 py-2 text-sm text-gray-700">
       #{item.order}  {item.name}  
      </div>
    );
  };

  const onSave = async () => {
    var result = await updateProductProcessStatuses(productId);
    if (!productId) return;

    if (result.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Process Status Updated",
          SnackbarType.Success
        )
      );
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">
              Product Process Status
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Manage process status assignments for this product.
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <button
              onClick={onSave}
              disabled={loading}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
            >
              {loading ? "Saving..." : "Save Assignments"}
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="w-full">
            <div className="bg-white">
              {loading || !updatedCurrentStatuses ? (
                <div className="p-6">
                  <div className="border rounded-md p-4">
                    <div className="animate-pulse">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
                      <div className="h-48 bg-gray-100 rounded"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <AssignPickList
                  source={updatedCurrentStatuses.availableStatuses}
                  target={updatedCurrentStatuses.currentProductStatuses}
                  updateStatus={setUpdatedCurrentStatuses}
                  sourceItemTemplate={sourceItemTemplate}
                  targetItemTemplate={targetItemTemplate}
                  sourceHeaderText={"Available Process Statuses"}
                  targetHeaderText={"Assigned Process Statuses"}
                  dataKey="id"
                  filter
                  filterBy="name"
                  style={{ minHeight: "320px" }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
